export default __webpack_public_path__ + "static/media/ifms-logo_White.98b6bb28.svg";